import Templater from '@hc-frontend/shared-assets/src/js/utils/dom/Templater'
import fetchJSONHandleError from 'utils/NET/fetchJSONHandleError'
import getPremium from 'core/controllerPlans/getPremium'
import moneyFormat from 'utils/format/money'
import innerHTML from 'utils/DOM/innerHTML'
import getById from 'utils/DOM/getById'
import store from 'utils/store/withMiddleware'
import { propAccessor } from '@hc-frontend/utils'
import {
  DENTAL,
  VISION_ID,
  AMERITAS_DENTAL,
  AMERITAS_VISION,
  RENAISSANCE_PRODUCTS,
  DENTAL_STAND_ALONE
} from 'core/constants/products'
import getResourceFromV2 from 'core/services/getResourceFromV2'
import { enableV2DentalPlanDetails } from 'utils/experiments'

const commonPathV2Details = 'products/dental/details/v2/'

const newPlanV2Details = {
  'Brilliant Dental™ Value': commonPathV2Details + 'dental-value',
  'Brilliant Dental™ Essential': commonPathV2Details + 'dental-essential',
  'Brilliant Dental™ Maximum': commonPathV2Details + 'dental-maximum'
}

function getPlanDetailsURL(stateAbbrev, planName) {
  if (stateAbbrev === 'CT' || stateAbbrev === 'IL') {
    return getResourceFromV2(
      `${newPlanV2Details[planName]}-${stateAbbrev.toLowerCase()}.json`
    )
  }
  return getResourceFromV2(newPlanV2Details[planName] + '.json')
}
function fetchPlanDetails(state, stateAbbrev, plan) {
  if (enableV2DentalPlanDetails() && (plan.productId == DENTAL_STAND_ALONE || plan.productId == DENTAL)) {
    return getPlanDetailsURL(stateAbbrev, plan.planName)
  }
  return fetchJSONHandleError({ url: state.jsons[plan.jsonId] })
}

function handleOpenModalDental(e) {
  e.preventDefault()
  const state = store.getState()
  const planId = +this.getAttribute('data-id')
  const dentalPlan = state.plans[planId]
  const contextPlanId = +this.getAttribute('data-planId')
  const templateModal = Templater(getById('template-dental-modal').innerText)
  const plansToShow = [dentalPlan]
  let total = getPremium(dentalPlan)

  const vision = RENAISSANCE_PRODUCTS.includes(dentalPlan.productId)
    ? state.plans[VISION_ID]
    : null
  if (vision) {
    total += getPremium(vision)
    plansToShow.push(vision)
  }

  const addonsByContextPlan = propAccessor(state.addonsByPlan, String(contextPlanId), [])
  const dentalAddonByContextPlan = propAccessor(
    state.dentalAddons,
    String(contextPlanId),
    undefined
  )

  const visionSelected =
    dentalPlan.productId === DENTAL &&
    (state.visionPlanId || addonsByContextPlan.includes(VISION_ID))

  const remove =
    state.dentalPlanId === planId ||
    state.planId === planId ||
    planId === dentalAddonByContextPlan

  const hasDental = remove && !visionSelected
  const hasVision = remove && visionSelected
  const hcStorage = state.hcStorage
  const stateAbbrev = hcStorage.location.state_acronym
  const isAmeritas =
    dentalPlan.productId === AMERITAS_DENTAL || dentalPlan.productId === AMERITAS_VISION

  Promise.all(plansToShow.map(plan => fetchPlanDetails(state, stateAbbrev, plan))).then(
    details => {
      innerHTML(
        '#addOnModal .modal-body',
        templateModal(
          {
            id: planId,
            title: plansToShow.map(item => item.planName).join(' + '),
            plans: plansToShow,
            details,
            remove,
            contextPlanId,
            hasDental,
            hasVision,
            total: moneyFormat(total),
            showWithPrice: true,
            ids: plansToShow.map(plan => plan.planId).join(','),
            brochures: state.brochures,
            isValue: /value/i.test(state.plans[planId].planName),
            stateAbbrev,
            isAmeritas,
            multiCarrier: propAccessor(
              state,
              ['plans', contextPlanId, 'multiCarrierPlan'],
              false
            )
          },
          {
            moneyFormat,
            getPremium
          }
        )
      )

      $('#addOnModal').modal('show')
    }
  )
}

export default handleOpenModalDental
